export const API_ENDPOINTS = {
  LINKS: '/api/links',
  PROFILE_PAGES: '/api/profile-pages',
  ANALYTICS: '/api/analytics',
  HEALTH: '/api/health',
  SERVER_INFO: '/api/server-info',
  AUTH: {
    LOGIN: '/api/auth/login',
    REGISTER: '/api/auth/register',
    PROFILE: '/api/auth/profile',
    REFRESH: '/api/auth/refresh',
    LOGOUT: '/api/auth/logout',
    LOGOUT_ALL: '/api/auth/logout-all',
    SESSIONS: '/api/auth/sessions',
    REVOKE_SESSION: '/api/auth/sessions',
    FORGOT_PASSWORD: '/api/auth/forgot-password',
    RESET_PASSWORD: '/api/auth/reset-password',
    VERIFY_EMAIL: '/api/auth/verify-email',
    RESEND_VERIFICATION: '/api/auth/resend-verification',
    PROVIDERS: '/api/auth/providers',
    GOOGLE_START: '/api/auth/google'
  },
  ADMIN: {
    DASHBOARD: '/api/admin/dashboard',
    USERS: '/api/admin/users',
    SYSTEM_HEALTH: '/api/admin/system/health',
    SYSTEM_ANALYTICS: '/api/admin/system/analytics',
    SETTINGS: '/api/admin/settings',
    PLANS: '/api/admin/plans',
    RATE_LIMITS: '/api/admin/settings/rate-limits',
    EXPORT_SETTINGS: '/api/admin/settings/export',
    IMPORT_SETTINGS: '/api/admin/settings/import'
  },
  SOCIAL: {
    SHARE_URLS: '/api/links/:shortCode/share',
    TRACK_SHARE: '/api/links/:shortCode/share',
    SHARE_STATS: '/api/links/:shortCode/share/stats'
  },
  BILLING: {
    PLANS: '/api/billing/plans',
    SUBSCRIPTION: '/api/billing/subscription',
    INVOICES: '/api/billing/invoices',
    CHECKOUT: '/api/billing/checkout',
    PORTAL: '/api/billing/portal',
    CANCEL: '/api/billing/cancel'
  }
};

export const HTTP_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE'
};

export const API_STATUS = {
  SUCCESS: 'success',
  ERROR: 'error',
  LOADING: 'loading'
};
